import { PaymentProcessorConfigurationBase } from '../payment-processor-configuration-base';

export class GWPaymentProcessorConfiguration extends PaymentProcessorConfigurationBase {

  // sandboxUrl: string = 'https://carrollcountyga.demositegw.com/permit.html';
  // productionUrl: string = 'https://carrollcountyga.governmentwindow.com/permit.html';

  constructor(options?: Partial<GWPaymentProcessorConfiguration>) {
    super(options);
    if (options) {
      Object.assign(this, options);
    }
  }
}